module.exports = __webpack_public_path__ + "static/img/company_history_renwu2020.5607c450.jpg";